import {CONTACT_PAGE, RENT_LIST_PAGE, RENT_PAGE, STUDIO_PAGE} from "../../Routes";

export type NavItem = {
    labelKey: string
    /** Where the item navigates to. */
    path: string
    /** Path prefix that marks the item as active. Defaults to `path`. */
    match?: string
    descriptionKey?: string
}

/** Single source of truth for the header, the menu drawer and the footer. */
export const NAV_ITEMS: NavItem[] = [
    {
        labelKey: 'lbl_rent_equipment',
        path: RENT_LIST_PAGE,
        match: RENT_PAGE,
        descriptionKey: 'lbl_nav_rent_desc'
    },
    {
        labelKey: 'lbl_studio',
        path: STUDIO_PAGE,
        descriptionKey: 'lbl_nav_studio_desc'
    },
    {
        labelKey: 'lbl_contact',
        path: CONTACT_PAGE,
        descriptionKey: 'lbl_nav_contact_desc'
    }
]

export const isNavItemActive = (item: NavItem, pathname: string) => {
    const match = item.match ?? item.path
    return match === '/' ? pathname === '/' : pathname.startsWith(match)
}
